import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getInvoiceDeatilsListAsync } from "../actions/invoiceDetailsGenerateActions";

interface InvoiceDetailItem {
  [key: string]: any;
}

interface PaginationState {
  pageNumber: number;
  count: number;
}

interface InvoiceDetailState {
  loading: boolean;
  invoiceDetails: InvoiceDetailItem[];
  pagination: PaginationState;
}

const initialState: InvoiceDetailState = {
  loading: false,
  invoiceDetails: [],
  pagination: {
    pageNumber: 1,
    count: 0,
  },
};

const invoiceDetailGenerationSlice = createSlice({
  name: "invoiceDetailGenerationSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Pending
    builder.addMatcher(
      isAnyOf(getInvoiceDeatilsListAsync.pending),
      (state) => {
        state.loading = true;
      }
    );

    // Rejected
    builder.addMatcher(
      isAnyOf(getInvoiceDeatilsListAsync.rejected),
      (state, action) => {
        if (action.payload && typeof action.payload === 'object' && (action.payload as { cancelled?: boolean }).cancelled) {
          return
        }
        state.loading = false;
      }
    );

    // Fulfilled
    builder.addMatcher(
      isAnyOf(getInvoiceDeatilsListAsync.fulfilled),
      (state, action) => {
        state.loading = false;

        const res = action.payload;
        state.invoiceDetails = res?.results ?? [];
        state.pagination.count = res?.count ?? 0;

        // Since this thunk receives { paramData: { page } }
        state.pagination.pageNumber = action.meta.arg.paramData.page ?? 1;
      }
    );
  },
});

export default invoiceDetailGenerationSlice.reducer;
